import React from 'react';

const HazelHeroIcon = (props: any) => {
  const { className, id } = props;

  return (
    <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
      width="753.000000pt" height="429.000000pt" viewBox="0 0 753.000000 428.000000"
      preserveAspectRatio="none" className={className} id={id}
    >
      <defs>
        <linearGradient id="hero-gradient">
          <stop id="hero-gradient-start" offset="0%" />
          <stop id="hero-gradient-end" offset="100%" />
        </linearGradient>
      </defs>
      <g id="hero-icon" transform="translate(0.000000,428.000000) scale(0.100000,-0.100000)">
        <path d="M0 2184 l0 -2107 88 7 c48 4 171 13 274 21 103 8 270 21 370 30 101
          8 271 22 378 30 107 9 301 24 430 35 129 11 352 29 495 40 143 11 341 27 440
          35 99 9 326 26 505 40 179 14 955 75 1725 135 1547 121 1461 111 1666 199 118
          51 185 92 276 169 202 172 346 456 402 792 149 895 441 2661 441 2669 0 8
          -1128 11 -3745 11 l-3745 0 0 -2106z"
        />
      </g>
    </svg>
  )
}

export default HazelHeroIcon